import { Grid, Typography } from "@material-ui/core";
import { TEXT_COLOR_FT } from "config/config";
import React from "react";


const SharedTitle = props => {
  const { title } = props
    const usr = JSON.parse(sessionStorage.getItem('user'));
  return (
    <Grid item xs={12} sm={12} md={12} style={{
      height:usr.organization.name.lenght >= 26 ?92:112,
      paddingBottom: 32,
      paddingTop: 33,
      paddingRight: 15,
      paddingLeft: 25,
      borderBottom: 'solid 1px',
      borderBottomColor: 'rgba(33,33,33,0.08)',
      color:TEXT_COLOR_FT
    }}>
      <Typography

        component="h1"
        variant="h1"
        style={{ display: 'flex', alignItems: 'left', margin: 0, fontSize:18, paddingTop:3, paddingBottom:2 }}>
        {title}
      </Typography>
    </Grid>
  )
}

export default SharedTitle